// assets
import { IconShield } from "@tabler/icons";

// constant
const icons = {
  IconShield,
};

// ==============================|| CONTRACARGOS MENU ITEMS ||============================== //

const contracargos = {
  id: "Contracargos",
  title: "",
  type: "group",
  children: [
    {
      id: "Contracargos",
      title: "Contracargos",
      type: "item",
      url: "/contracargos/contracargos-list",
      icon: icons.IconShield,
      breadcrumbs: false,
    },
  ],
};

export default contracargos;
